interface Option {
  label: string;
}

interface AutocompleteState {
  inputValue: string;
}

const CustomAutocompleteFilter = (
  options: Option[],
  state: AutocompleteState
): Option[] => {
  const { inputValue } = state;
  const searchText = inputValue.toUpperCase();

  const transformSearchText = (text: string) => {
    return text
      .replace(
        /UG(\d+)?-INV(\d+)?/,
        (_, g, i) =>
          `UG${g ? g.padStart(2, "0") : "00"}-IV${
            i ? i.padStart(2, "0") : "00"
          }`
      )
      .replace(
        /UG(\d+)?-TRF/,
        (_, g) => `UG${g ? g.padStart(2, "0") : "00"}-CTRF`
      )
      .replace(
        /UG(\d+)?-TRK(\d+)?/,
        (_, g) => `UG${g ? g.padStart(2, "0") : "00"}-TRAC`
      );
  };

  console.log("Transformed Search Text:", transformSearchText(searchText));

  const searchResult = options.filter((option) => {
    const labelUpperCase = option.label.toUpperCase();
    const transformedSearchText = transformSearchText(searchText);
    const transformedLabel = transformSearchText(labelUpperCase);
    return transformedLabel.includes(transformedSearchText);
  });

  console.debug("DEBUG filterOption", {
    searchText,
    options,
    searchResult,
  });

  return searchResult;
};

export default CustomAutocompleteFilter;
